import React from 'react';
import '../../css/tabulky.css';
import Transcription from "./Transcription";

class AD1ResultTableNew extends React.Component {

    doResult(result, fromRank) {
        let preRank = fromRank;
        let preTime = 0;

        for (let i = 0; i < result.length; i++) {
            const athlet = result[i];
            const first = result[0].cas
            if (athlet.cas === preTime) {
                athlet.poradi = "=" + preRank;
            } else {
                preRank = i + 1 + fromRank;
                preTime = athlet.cas;
                athlet.poradi = preRank;
            }
            if (i > 0 && result.length > 1) {
                athlet.ztrata = athlet.cas - first;
            } else athlet.ztrata = 0;
        }
        return result;
    }

    render() {
        let atleti = [];
        if (this.props.raceInfo.koloZavodu === 2) {
            let r1k = [];
            let r2k = [];
            for (let i = 0; i < this.props.athletes.length; i++) {
                if (this.props.athletes[i].cas2 === 0) {
                    r1k.push(this.props.athletes[i]);
                } else r2k.push(this.props.athletes[i]);
            }

            atleti = this.doResult(r2k, 0).concat(this.doResult(r1k, r2k.length));
        } else atleti = this.props.athletes;
        let proto = this.props.protocol;

        if (atleti.length > 0)
            for (let i = 0; i < proto.length; i++) {
                if (typeof proto[i].poradi === 'number') {
                    try {
                        proto[i].poradi = atleti.find(({stc}) => stc === proto[i].stc).poradi
                        if (proto[i].poradi === 1) {
                            proto[i].ztrata = -atleti[1].ztrata
                        }
                    } catch (err) {

                    }
                }
            }
        let onCourse = this.props.inProgress.map((athlet, key) => (
            <tr key={key}>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.bib}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.jmeno}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.tj.localeCompare("    ") === 0 ? athlet.klub : athlet.tj}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.zkrkat}</td>
            </tr>
        ));
        let protocol = proto.map((athlet, key) => (
            <tr key={key}>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{isNaN(athlet.poradi) ? athlet.poradi : athlet.poradi + '.'}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.bib}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.jmeno}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes)}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.tj.localeCompare("    ") === 0 ? athlet.klub : athlet.tj}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas1, this.props.raceInfo.pocDes)}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas2, this.props.raceInfo.pocDes)}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas3, this.props.raceInfo.pocDes)}</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.zkrkat}</td>
            </tr>
        ));

        let row =
            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
            </tr>;
        let oneRow = <>
            {protocol}
            {row}
        </>
        let twoRows = <>
            {protocol}
            {row}
            {row}
        </>;
        let threeRows = <>
            {row}
            {row}
            {row}
        </>;
        let oneRowC = <>
            {onCourse}
            {row}
        </>
        let twoRowsC = <>
            {onCourse}
            {row}
            {row}
        </>;
        let hiddenRow =
            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
            </tr>;
        return (
             // <div className="body2">
                <div className="card">
                    <div className="cardContent">
                        <table id="druha">
                            <tbody>
                            {hiddenRow}
                            {/*<tr>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*    <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>*/}
                            {/*</tr>*/}
                            <tr>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Poř.</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Stč.</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Jméno</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Čas</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>klub</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Čas 1</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Čas 2</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Čas 3</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>&nbsp;</th>
                                <th style={{backgroundColor: '#052d93', color: '#fff', fontWeight: '700'}}>Kat.</th>
                            </tr>
                            <tr>
                                <th style={{backgroundColor: '#0096ff', color: '#fff'}} colSpan={10}>
                                    Na trati
                                </th>
                            </tr>
                            {this.props.inProgress.length === 0 ? threeRows : this.props.inProgress.length === 1 ? twoRowsC :
                                this.props.inProgress.length === 2 ? oneRowC : onCourse}
                            <tr style={{backgroundColor: '#0096ff', color: '#fff'}}>
                                <th colSpan="10">
                                    Události v cíli
                                </th>
                            </tr>
                            {this.props.protocol.length === 0 ? threeRows : this.props.protocol.length === 1 ? twoRows :
                                this.props.protocol.length === 2 ? oneRow : protocol}
                            <tr style={{backgroundColor: '#0096ff', color: '#fff'}}>
                                <th colSpan="2">Výsledky</th>
                                <th colSpan="8">DNS: {this.props.stat[0]} - Na startu: {this.props.stat[1]} - Na
                                    trati: {this.props.stat[2]} - V cíli: {this.props.stat[3]} -
                                    DSQ: {this.props.stat[4]} - DNF: {this.props.stat[5]}</th>
                            </tr>

                            {atleti.map((athlet, key) => (
                                <tr key={key}>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{isNaN(athlet.poradi) ? athlet.poradi : athlet.poradi + '.'}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.bib}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.jmeno}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas, this.props.raceInfo.pocDes)}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.tj.localeCompare("    ") === 0 ? athlet.klub : athlet.tj}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas1, this.props.raceInfo.pocDes)}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas2, this.props.raceInfo.pocDes)}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.transposeTime(athlet.cas3, this.props.raceInfo.pocDes)}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>&nbsp;</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.zkrkat}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
             // </div>
        )
    }
}

export default AD1ResultTableNew;